import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  PaymentMethod,
  PaymentMethodState
} from '@/modules/settings/paymentMethod/types/types.ts'

const initialState: PaymentMethodState = {
  selected: undefined,
  isOpenModal: false,
  isDeleteModalOpen: false
}

const paymentMethodSlice = createSlice({
  name: 'paymentMethods',
  initialState,
  reducers: {
    setSelected: (state, action: PayloadAction<PaymentMethod | undefined>) => {
      state.selected = action.payload
    },
    setOpenModal: (state, action: PayloadAction<boolean>) => {
      state.isOpenModal = action.payload
    },
    setDeleteOpenModal: (state, action: PayloadAction<boolean>) => {
      state.isDeleteModalOpen = action.payload
    }
  }
})

export const paymentMethodsActions = paymentMethodSlice.actions
export const { reducer: paymentMethodsReducer } = paymentMethodSlice
